import classNames from 'classnames'
import React from 'react'
import { useRecoilValue } from 'recoil'
import { useRandomDefaultValue } from '../../../../hooks'
import { ODAppBarThemeType } from '../../../../interfaces/gnbInterfaces'
import { useGlobalContext } from '../../../global'
import { Hoverable } from '../../../styled'
import { gnbSelectedMenuItem } from '../../gnbCommon'
import { useGNBContext } from '../../ODGNBProvider'
export var ODGNBTextMenu = function (props) {
  var _a = props.def,
    linkable = _a.linkable,
    _globalKey = _a.globalKey,
    className = _a.className,
    dropdown = props.insideDropdown
  var _b = useGlobalContext(),
    factory = _b.factory,
    convertThemeString = _b.convertThemeString
  var _c = useGNBContext().state.def,
    position = _c.position,
    _d = _c.textColor,
    textColor = _d === void 0 ? '#9c9c9c' : _d,
    theme = _c.theme
  var globalKey = useRandomDefaultValue(_globalKey)
  var selected = useRecoilValue(gnbSelectedMenuItem) === globalKey
  var topBar = position === 'top'
  var isCui = theme.type === ODAppBarThemeType.CoreUILike
  var cn = classNames(
    'text-sm font-semibold text-gray-900 focus:outline-none focus:shadow-outline',
    {
      'px-4 py-2': !isCui,
      'pl-4': isCui && !dropdown,
      block: !topBar,
      'text-gray-900': !dropdown,
      'dark-mode:bg-gray-700': !dropdown,
      'dark-mode:bg-transparent': dropdown,
      'bg-gray-200': selected,
      'bg-transparent': !selected,
      'md:mt-0': topBar || dropdown,
      'md:ml-4': topBar,
      'mt-2': !isCui,
      flex: isCui,
      'items-center': isCui,
      'hover:bg-gray-200': !isCui,
      'rounded-lg': !isCui,
      'rounded-none': isCui,
    },
    className
  )
  var cuiTheme = theme
  var style = {
    color: convertThemeString(textColor),
    height: isCui && !dropdown ? cuiTheme.size : undefined,
    margin: isCui && dropdown ? 4 : undefined,
    padding: isCui && dropdown ? 0 : undefined,
  }
  var hoverColor = isCui ? (dropdown ? cuiTheme.hoverColorDropdown : cuiTheme.hoverColor) : undefined
  return React.createElement(
    Hoverable,
    { className: cn, style: style, hoverColor: convertThemeString(hoverColor) },
    factory.renderLinkable(globalKey, linkable, 'w-full h-full flex items-center')
  )
}
//# sourceMappingURL=ODGNBTextMenu.js.map
